import Head from "next/head";
import PageLayout from "@/components/PageLayout";
import AgencyService from "@/lib/services/agencies.js"; 
import {useState, useRef} from 'react'; 
import Qs from 'qs'; 
import searchTranslator from '@/lib/search_translator.js'
import SearchBuilder from '@/components/search_builder.js' 
import debounce from 'lodash.debounce';
import {loadConfig} from '@/lib/utils.js'
import AnalyticService from "@/lib/services/analytics";
import AgencyLocatorTileListView from '@/components/agency_locator_tile_list_view'
import AgencyMapView from '@/components/agency_map_view'

function AgentLocator(results) {
  const {favicon, stylesheet, page_layout, cart_enabled, use_map_on_agency_locator_page} = results
  const {agencies, total_count, state_province_filters, initialSearch} =  results;
  const stateOptions = state_province_filters ? state_province_filters.us_states : []  
  const provinceOptions =  state_province_filters ? state_province_filters.canadian_provinces : [] 
  const mexicanStateOptions =   state_province_filters ? state_province_filters.mexican_states : [] 
  const countryOptions = state_province_filters ? state_province_filters.countries : []
  const [currentMap, setCurrentMap] = useState('US'); 

  const stateProvinceOptions = function( )  {
    let opts = []
    if(!use_map_on_agency_locator_page || currentMap == 'US') {
      stateOptions.forEach((opt) => {
        opts.push({label: opt[0], value: opt[1] } )
      })
    }
    if(!use_map_on_agency_locator_page || currentMap == 'CAN') {
      if (!use_map_on_agency_locator_page && provinceOptions?.length > 0 ) {
        opts.push({label: '--Canadian--'})
      }
      provinceOptions.forEach((opt) => {
        opts.push({label: opt[0], value: opt[1] } )
      })
    }
    if(!use_map_on_agency_locator_page || currentMap == 'MX') {
      if (!use_map_on_agency_locator_page && mexicanStateOptions?.length > 0 ) {
        opts.push({label: '--States of Mexico--'})
      }
      mexicanStateOptions.forEach((opt) => {
        opts.push({label: opt[0], value: opt[1] } )
      })
    }

    return opts; 
  }();

 const [isLoading, setIsLoading] = useState(false);
 const [agents, setAgents] = useState(agencies)
 const [totalCount, setTotalCount] = useState(total_count)

 const searchAgencies = (search) => {
    setIsLoading((currentIsLoaded) => true);
    fetch('/lex-api/agencies/locator' + '?' +  Qs.stringify(search, {arrayFormat: 'brackets', encode: true}))
      .then((res) => res.json())
      .then((data) => {
        setIsLoading((currentIsLoaded) => false);
        setAgents(data.agencies)
        setTotalCount(data.total_count)
      })
  }

  const  agencyNameSearch = debounce((value, searchState) => {
     searchState.addValueAtKey('q[name_cont]', value)

    }, 200)

   const searchInput = useRef(null)
   const sharedProps = {
     agencyNameSearch:agencyNameSearch,
     stateProvinceOptions:stateProvinceOptions,
     searchAgencies:searchAgencies,
     isLoading:isLoading,
     countries: countryOptions,
     agents:agents,
     totalCount:totalCount,
     searchInput:searchInput,
     setCurrentMap: setCurrentMap,
     currentMap: currentMap
   }
  return (
    <PageLayout favicon={favicon} page_layout={page_layout} stylesheet={results.stylesheet} title={'Agency Locator'} cart_enabled={cart_enabled}>
      <SearchBuilder initialSearch={initialSearch} search={searchAgencies}> 
        {(searchState) =>  {
          return use_map_on_agency_locator_page ? (<AgencyMapView provinces={provinceOptions} states={stateOptions } {...sharedProps} searchState={searchState} />) : ( <AgencyLocatorTileListView  {...sharedProps}
            searchState={searchState}
            />

          )
        }
        }
      </SearchBuilder>
    </PageLayout>
  );
}

export async function getServerSideProps(context) {

  let token = context?.req?.headers['lex-api-token'] 
  let service = await AgencyService.build(token, context.req?.headers.host)
  let q =  searchTranslator(context.query)
  let apiFriendlyQ = searchTranslator(context.query, true)
  let search = await service.index(apiFriendlyQ)
  search.initialSearch = q
  try {
    let analyticService = new AnalyticService(token, {}, true);
    let data = { 
      agency_locator_query: q
    }
    analyticService.recordAgencyLocatorVisited(data, context.req?.headers);
  } 
  catch (e) {
    console.log(e);
  }
  let pageLayout = loadConfig(service);
  return {
    props:  {...search, ...pageLayout}
  }
}

export default AgentLocator;
